import Head from 'next/head';
import { NextSeo } from 'next-seo';
import { Warehouse } from '@/screens/Warehouse';

export default function WarehousePage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Warehouse solutions, WMS, warehouse management systems, dock scheduling software, dock scheduling technology, warehouse technology, warehouse software solutions"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Warehouse Solutions"
        description="Discover new warehouse solutions for your business. Our cutting-edge technology and expertise will help you optimize your inventory management, reduce costs, and increase efficiency. From automation to real-time tracking, we've got you covered."
        canonical="https://loadsmart.com/warehouse/"
        openGraph={{
          url: 'https://loadsmart.com/warehouse/',
        }}
      />
      <Warehouse />
    </>
  );
}
